export var MenuButtonVariants;
(function (MenuButtonVariants) {
    MenuButtonVariants["neutral"] = "neutral";
    MenuButtonVariants["primary"] = "primary";
    MenuButtonVariants["secondary"] = "secondary";
    MenuButtonVariants["neutralOff"] = "neutralOff";
})(MenuButtonVariants || (MenuButtonVariants = {}));
export var MenuButtonSizes;
(function (MenuButtonSizes) {
    MenuButtonSizes["medium"] = "medium";
    MenuButtonSizes["large"] = "large";
    MenuButtonSizes["full"] = "full";
})(MenuButtonSizes || (MenuButtonSizes = {}));
//# sourceMappingURL=constants.js.map